import { BillingBannerType } from "@repo/app-types/entities/company";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { FC } from "react";
import { Link } from "react-router";
import { appPaths } from "../../app/appPaths.js";
import { useAppSelector } from "../../hooks/hook.js";
import { selectCompany } from "../company/companySlice.js";

export const BillingBanner: FC = () => {
  const company = useAppSelector(selectCompany);

  const billingBanner = company?.settings?.billing_banner;
  if (!billingBanner) {
    return null;
  }

  const isFountainCustomer = company?.billing_current_plan === "fountain-1";

  const interviewCreditsContent = isFountainCustomer ? (
    <span className="font-semibold">interview credits</span>
  ) : (
    <Link
      className="font-semibold underline"
      to={appPaths.settingsBilling.build()}
    >
      interview credits
    </Link>
  );

  const contactMessage = isFountainCustomer
    ? "Reach out to your Fountain account manager"
    : "Contact support@alpharun.com";

  if (billingBanner === BillingBannerType.Expired) {
    return (
      <div className="flex h-9 w-full flex-row items-center justify-center space-x-2 bg-gray-700 text-center text-sm leading-9 text-white">
        <IconAlertTriangle className="h-6 w-6 text-destructive" />
        <span className="truncate">
          {"You've used all your "}
          {interviewCreditsContent}
          {`. ${contactMessage} to avoid service disruption.`}
        </span>
      </div>
    );
  }

  if (billingBanner === BillingBannerType.Warning) {
    return (
      <div className="flex h-9 w-full flex-row items-center justify-center space-x-2 bg-gray-700 text-center text-sm leading-9 text-white">
        <IconAlertTriangle className="h-6 w-6 text-amber-500" />
        <span className="truncate">
          {"You're running low on "}
          {interviewCreditsContent}
          {`. ${contactMessage} to add more and avoid service disruption.`}
        </span>
      </div>
    );
  }

  if (billingBanner === BillingBannerType.ExpiringSoon) {
    return (
      <div className="flex h-9 w-full flex-row items-center justify-center space-x-2 bg-gray-700 text-center text-sm leading-9 text-white">
        <IconAlertTriangle className="h-6 w-6 text-amber-500" />
        <span className="truncate">
          {`Your subscription is ending soon. ${contactMessage} to avoid service disruption.`}
        </span>
      </div>
    );
  }

  return null;
};
